/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import axios from 'axios';
import * as actionTypes from './ActionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';

export const setCalInterestTab = (data) => ({
  type: actionTypes.CALCULATE_INTEREST_TAB_DATA,
  calInterestObj: data,
});

export const dispatchQuarterData = (data) => ({
  type: actionTypes.GET_QUARTER_DATA,
  quarter: data,
});

export const getQuarterData = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_QUARTER_DATA)
    .then((response) => {
      return dispatch(
        dispatchQuarterData(response.data && response?.data?.data)
      );
    })
    .catch(() => {
      dispatch(dispatchQuarterData([]));
    });
};
export const dispatchCommonDropdownData = (data) => ({
  type: actionTypes.GET_COMMON_DROPDOWN_DATA_CI,
  dropdown: data,
});

export const getCommonDropdownList = (value) => {
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      //  return dispatch(dispatchCommonDropdownData(response.data));
      return response.data;
    })
    .catch(() => {
      //  dispatch(dispatchCommonDropdownData([]));
      return [];
    });
};
export const dispatchManufacturerData = (data) => ({
  type: actionTypes.GET_MANUFACTURER_GRID_LIST,
  manufacturerList: data,
});
export const getManufacturerList = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_MFG_LIST_FOR_CAL_INTEREST, value)
    .then((response) => {
      return dispatch(
        dispatchManufacturerData(
          response.data && response.data.manufacturerResponseVOs
        )
      );
    })
    .catch(() => {
      dispatch(dispatchManufacturerData([]));
    });
};
export const dispatchCalculateInterest = (data) => ({
  type: actionTypes.GET_CALCULATE_INTEREST_FOR_NDC_MFG,
  getAllCalculateInterestList: data,
});
export const displayNetworkErr = (payload) => ({
  type: actionTypes.NETWORK_ERROR_CALC_INT,
  payload,
});
export const getCalculateInterestList = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_CALCULATE_INTEREST_FOR_NDC_MFG, value)
    .then((response) => {
      return dispatch(dispatchCalculateInterest(response.data));
    })
    .catch((error) => {
      dispatch(dispatchCalculateInterest([]));
      if (
        error.message === 'Network Error' ||
        error.message === 'Request failed with status code 502'
      ) {
        dispatch(displayNetworkErr(true));
      }
    });
};
export const dispatchValidationCalculateInterest = (data) => ({
  type: actionTypes.GET_VALIDATION_CALCULATE_INTEREST,
  getAllVerifyCalInterestList: data,
});
export const getValidationCalculateInterestList = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_VALIDATION_CALCULATE_INTEREST, value)
    .then((response) => {
      return dispatch(
        dispatchValidationCalculateInterest(
          response.data && response.data.errorsVO
        )
      );
    })
    .catch(() => {
      dispatch(dispatchValidationCalculateInterest([]));
    });
};
export const handleErrorMessages = (data) => ({
  type: actionTypes.HANDLE_ERROR_MESSAGE_FOR_CAL_INT,
  errorMessagesInRedux: data,
});
export const handleSuccessMessages = (data) => ({
  type: actionTypes.HANDLE_SUCCESS_MESSAGE_FOR_CAL_INT,
  successMessageInRedux: data,
});

export const clearReduxforCalculateInterestSearch = () => (dispatch) => {
  dispatch(setCalInterestTab({}));
  dispatch(handleErrorMessages([]));
  dispatch(handleSuccessMessages([]));
  dispatch(dispatchCalculateInterest([]));
  dispatch(dispatchManufacturerData([]));
  dispatch(dispatchValidationCalculateInterest([]));
};

export const calcInterestDetail = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.VIEW_CALCULATED_INTEREST}`, value)
    .then((response) => response.data)
    .catch((error) => error);
};

export const ndcForDetail = (payload) => ({
  type: actionTypes.DETAIL_DATA_CAL_INT,
  payload,
});
